import { render } from "./monthsummary.vue?vue&type=template&id=6cb988f0"
import script from "./monthsummary.vue?vue&type=script&lang=js"
export * from "./monthsummary.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__